/**
 * Thin wrapper that canonicalizes a value for preview purposes.
 *
 * This is NOT a security-grade canonicalizer (that's the mock signer
 * for Spark; the real JCS canonicalizer is in Rust). We pretty-print
 * with sorted keys and 2-space indent so the user can read what will
 * be signed without squinting at a minified blob.
 */

export function canonicalJsonPreview(value: unknown): string {
  return JSON.stringify(sortKeys(value), null, 2);
}

function sortKeys(v: unknown): unknown {
  if (v === null || typeof v !== 'object') return v;
  if (Array.isArray(v)) return v.map(sortKeys);
  const entries = Object.entries(v as Record<string, unknown>)
    .filter(([, val]) => val !== undefined)
    .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
  const out: Record<string, unknown> = {};
  for (const [k, val] of entries) out[k] = sortKeys(val);
  return out;
}
